<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <NotificationsBar v-show="defaultSite" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <NotificationsList v-if="defaultSite" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import NotificationsBar from '@/Core.Service.Domain/ViewSupport/Notifications/Components/NotificationsBar.vue';

import NotificationsList from '@/Core.Service.Domain/ViewSupport/Notifications/Components/NotificationsList.vue';

export default {
  name: 'NotificationsView',

  components: {
    NotificationsList,
    NotificationsBar,
  },

  computed: {
    ...mapGetters({
      defaultSite: 'session/defaultSite',
      isLoading:
        'ViewSupportStore/NotificationsStore/getNotificationsIsLoading',
    }),
  },
};
</script>
